import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { useState } from 'react';
import Pagination from '@mui/material/Pagination';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import bydsealion7 from './images/byd-sealion-7.jpg';
import bydsealionHarga from './images/byd-sealion-7-connectivity-23.jpg';
import bydsealionSpek from './images/byd-sealion-7-connectivity-24.jpg';
import bydsealionTempat from './images/byd-sealion-7-exterior-03.jpg';
import bydsealionKeunggulan from './images/byd-sealion-7-exterior-04.jpg';
import bydsealionRamah from './images/byd-sealion-7-interior-06.jpg';
import bydsealionKeluarga from './images/byd-sealion-7-interior-07.jpg';
import bydsealionPesan from './images/byd-sealion-7-interior-13.jpg';
import bydsealionSerpong from './images/byd-sealion-7-interior-14.jpg';
import seagullpeluncuran from './images/BYD-SEAGULL-Launch-Indonesia.jpg';
import warnaseagull from './images/2023-04-28-104821-1024x768.jpg';
import interiorseagull from './images/interior-seagull-8.jpg';
import exteriorseagull from './images/seagull-sg-5.png';
import seagullfitur from './images/seagull-fitur.jpg';
import denzad9spect from './images/byd-denza-d9-side.jpeg'

const blogs = [
  {
    id: 1,
    title: 'Kenapa Memilih BYD Sealion 7 sebagai Mobil Listrik Anda?',
    description:
      'Cari tahu alasan BYD Sealion 7 menjadi pilihan terbaik untuk mobil listrik modern.',
    image: bydsealion7,
    slug: 'kenapa-memilih-byd-sealion-7',
    contentLength: '450 kata',
  },
  {
    id: 2,
    title: 'Harga BYD Sealion 7: Apa yang Membuatnya Bernilai Tinggi?',
    description:
      'Detail tentang harga dan keunggulan dari mobil listrik BYD Sealion 7.',
    image: bydsealionHarga,
    slug: 'harga-byd-sealion-7',
    contentLength: '500 kata',
  },
  {
    id: 3,
    title: 'Spesifikasi Lengkap BYD Sealion 7',
    description:
      'Jelajahi spesifikasi BYD Sealion 7, SUV listrik inovatif dengan performa tinggi.',
    image: bydsealionSpek,
    slug: 'spesifikasi-lengkap-byd-sealion-7',
    contentLength: '550 kata',
  },
  {
    id: 4,
    title: 'Dealer Resmi BYD Serpong: Tempat Membeli BYD Sealion 7',
    description:
      'Temukan BYD Sealion 7 di Dealer Resmi BYD BSD Serpong dengan penawaran menarik.',
    image: bydsealionTempat,
    slug: 'dealer-resmi-byd-serpong',
    contentLength: '400 kata',
  },
  {
    id: 5,
    title: 'Keunggulan Teknologi di BYD Sealion 7',
    description:
      'Pelajari fitur teknologi canggih yang menjadikan BYD Sealion 7 unggul di kelasnya.',
    image: bydsealionKeunggulan,
    slug: 'keunggulan-teknologi-byd-sealion-7',
    contentLength: '600 kata',
  },
  {
    id: 6,
    title: 'BYD Sealion 7: Mobil Listrik Ramah Lingkungan',
    description:
      'Cari tahu bagaimana BYD Sealion 7 berkontribusi pada lingkungan dengan teknologi hijau.',
    image: bydsealionRamah,
    slug: 'byd-sealion-7-ramah-lingkungan',
    contentLength: '500 kata',
  },
  {
    id: 7,
    title: 'BYD Sealion 7: Mobil Listrik untuk Keluarga Modern',
    description:
      'Ketahui kenapa BYD Sealion 7 adalah pilihan ideal untuk keluarga yang aktif.',
    image: bydsealionKeluarga,
    slug: 'mobil-listrik-keluarga-byd-sealion-7',
    contentLength: '450 kata',
  },
  {
    id: 8,
    title: 'Cara Memesan BYD Sealion 7 di Dealer Serpong',
    description:
      'Panduan lengkap untuk memesan BYD Sealion 7 melalui Dealer BYD Serpong.',
    image: bydsealionPesan,
    slug: 'cara-memesan-byd-sealion-7',
    contentLength: '400 kata',
  },
  {
    id: 9,
    title: 'Promo Terbaru untuk BYD Sealion 7 di Serpong',
    description:
      'Dapatkan promo menarik saat membeli BYD Sealion 7 di Dealer BYD Serpong.',
    image: bydsealionSerpong,
    slug: 'promo-byd-sealion-7-serpong',
    contentLength: '450 kata',
  },
  {
    id: 10,
    title: 'BYD atto1: Mobil Listrik Mungil dan Canggih',
    description:
      'Kenali fitur, teknologi, dan keunggulan BYD v sebagai city car masa depan.',
    image: seagullpeluncuran,
    slug: 'peluncuran-byd-seagull-indonesia',
    isStaticRoute: true,
  },
  {
    id: 11,
    title: 'BYD Atto1: Pilihan Warna BYD atto1 di Indonesia',
    description:
      'Segera pilih warna favorit kamu untuk pembelian BYD Atto1 di Indonesia.',
    image: warnaseagull,
    slug: 'pilihan-warna-byd-Atto1',
    isStaticRoute: true,
  },
  {
    id: 12,
    title: 'BYD Atto1: Intip Interior Atto1 Indonesia',
    description: 'Ini dia interior BYD Atto1 di Indonesia.',
    image: interiorseagull,
    slug: 'interior-byd-Atto1',
    isStaticRoute: true,
  },
  {
    id: 13,
    title: 'BYD Atto1: Detail Eksterior Atto1 yang Stylish',
    description:
      'Lihat desain eksterior BYD Atto1 yang modern dan cocok untuk jalanan Indonesia.',
    image: exteriorseagull,
    slug: 'eksterior-byd-Atto1',
    isStaticRoute: true,
  },
  {
    id: 14,
    title: 'BYD Atto1: Lihat Tampilan Eksterior Atto1 yang Futuristik',
    description:
      'Desain luar BYD Atto1 tampil modern, stylish, dan cocok untuk gaya hidup urban masa kini.',
    image: seagullfitur,
    slug: 'fitur-byd-Atto1',
    isStaticRoute: true,
  },
  {
    id: 15,
    title: 'BYD Denza D9 Indonesia: Mobil Listrik Canggih dengan Performa Tinggi',
    description: 'BYD Denza D9, mobil listrik 2025 untuk rakyat Indonesia. Performa tinggi, desain mewah, dan teknologi canggih kini hadir di BSD Serpong.',
    image: denzad9spect,
    slug: 'byd-denzaD9-indonesia', //isi url
    isStaticRoute: true,
  },
  {
    id: 16,
    title: '',
    description: '',
    image: seagullfitur,
    slug: '', //isi url
    isStaticRoute: true,
  },
];

function Blog() {
  const [page, setPage] = useState(1);
  const blogsPerPage = 6;

  const validBlogs = blogs
    .filter((b) => b.title && b.slug)
    .sort((a, b) => b.id - a.id);

  const startIndex = (page - 1) * blogsPerPage;
  const endIndex = startIndex + blogsPerPage;
  const currentBlogs = validBlogs.slice(startIndex, endIndex);

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <Box sx={{ padding: 4 }}>
      <br />
      <br />
      <br />
      <br />

      <Helmet>
        <title>Artikel Blog Terbaru | Mobil Listrik BYD</title>
        <meta
          name='description'
          content='Jelajahi artikel terbaru tentang mobil listrik BYD. Pelajari tips, panduan, dan perbandingan untuk memilih mobil listrik terbaik.'
        />
        <meta
          name='keywords'
          content='Mobil Listrik BYD, BYD BSD Serpong, Harga Mobil Listrik BYD, Promo Mobil Listrik BYD, Dealer Resmi BYD'
        />
        <meta name='author' content='BYD BSD Serpong' />
        <meta
          property='og:title'
          content='Artikel Blog Terbaru | Mobil Listrik BYD'
        />
        <meta
          property='og:description'
          content='Pelajari tentang mobil listrik BYD dari artikel terbaru kami. Temukan tips membeli, promo menarik, dan panduan memilih kendaraan listrik.'
        />
        <meta
          property='og:image'
          content='https://bydbsdserpong.com/images/blog-og-image.jpg'
        />
        <meta property='og:url' content='https://bydbsdserpong.com/blog' />
        <meta property='og:type' content='website' />
        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content='Artikel Blog Terbaru | Mobil Listrik BYD'
        />
        <meta
          name='twitter:description'
          content='Panduan, tips, dan informasi terkini tentang mobil listrik BYD dari Dealer Resmi BSD Serpong.'
        />
        <meta
          name='twitter:image'
          content='https://bydbsdserpong.com/images/blog-twitter-image.jpg'
        />
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Blog',
            name: 'Artikel Blog BYD BSD Serpong',
            description:
              'Informasi terbaru tentang mobil listrik BYD Sealion 7 dari Dealer Resmi BSD Serpong.',
            blogPost: blogs.map((blog) => ({
              '@type': 'BlogPosting',
              headline: blog.title,
              image: `https://bydbsdserpong.com${blog.image}`,
              url: `https://bydbsdserpong.com/blog/${blog.slug}`,
              description: blog.description,
              wordCount: blog.contentLength
                ? parseInt(blog.contentLength.replace(' kata', ''), 10)
                : undefined,
              author: {
                '@type': 'Person',
                name: 'Admin',
              },
              publisher: {
                '@type': 'Organization',
                name: 'BYD BSD Serpong',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://bydbsdserpong.com/logo.png',
                },
              },
              datePublished: '2025-01-18',
            })),
          })}
        </script>
      </Helmet>
      <Breadcrumbs aria-label='breadcrumb' sx={{ marginBottom: 2 }}>
        <Link underline='hover' color='inherit' component={RouterLink} to='/'>
          Home
        </Link>
        <Typography color='text.primary'>Blog</Typography>
      </Breadcrumbs>

      <Typography
        variant='h1'
        component='h1'
        fontWeight='bold'
        sx={{
          textAlign: 'center',
          marginBottom: 4,
          fontSize: { xs: '2rem', sm: '2.5rem' },
        }}
      >
        Artikel Blog Terbaru
      </Typography>

      {currentBlogs.length === 0 ? (
        <Typography color='error' textAlign='center' mt={4}>
          Tidak ada artikel blog yang tersedia.
        </Typography>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: '1fr 1fr',
              md: '1fr 1fr 1fr',
            },
            gap: 4,
          }}
        >
          {currentBlogs.map((blog) => (
            <Card
              key={blog.id}
              sx={{
                maxWidth: '100%',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s',
                '&:hover': {
                  transform: 'scale(1.02)',
                },
              }}
            >
              <CardMedia
                component='img'
                height='200'
                image={blog.image}
                alt={`${blog.title} - ${blog.description}`}
                sx={{ objectFit: 'cover' }}
              />
              <CardContent>
                <Typography
                  variant='h6'
                  fontWeight='bold'
                  sx={{ marginBottom: 1 }}
                >
                  {blog.title}
                </Typography>
                <Typography variant='body2' sx={{ marginBottom: 1 }}>
                  {blog.description}
                </Typography>
                <Typography
                  variant='body2'
                  sx={{ color: 'gray', marginBottom: 2 }}
                >
                  Panjang artikel: {blog.contentLength}
                </Typography>
                <Button
                  component={RouterLink}
                  to={`/blog/${blog.slug}`}
                  variant='contained'
                  color='primary'
                >
                  Baca Selengkapnya
                </Button>
              </CardContent>
            </Card>
          ))}
        </Box>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Pagination
          count={Math.ceil(validBlogs.length / blogsPerPage)}
          page={page}
          onChange={handlePageChange}
          color='primary'
        />
      </Box>
    </Box>
  );
}

export default Blog;
